import { Routes, Route, useLocation } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { AppInfoProvider, useAppInfoContext } from './contexts/AppInfoContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AppLayout } from './components/layout/AppLayout';
import { Login } from './components/auth/Login';
import { PasswordReset } from './components/auth/PasswordReset';
import { SharedDocument } from './components/features/SharedDocument';

function RouteDebugger() {
  const location = useLocation();
  
  useEffect(() => {
    console.log('🌐 App Router: Current route:', location.pathname);
    console.log('🌐 App Router: Current search:', location.search);
    console.log('🌐 App Router: Current hash:', location.hash);
  }, [location]);
  
  return null;
}

function AppContent() {
  const { appInfo } = useAppInfoContext();

  useEffect(() => {
    document.title = appInfo.name;
  }, [appInfo.name]);

  return (
    <Box minH="100vh" bg="gray.50" _dark={{ bg: 'gray.900' }}>
      <RouteDebugger />
        <Routes>
          <Route path="/auth/login" element={<Login />} />
          <Route path="/auth/password-reset" element={<PasswordReset />} />
          <Route
            path="/shared/*"
            element={
              <ProtectedRoute>
                <SharedDocument />
              </ProtectedRoute>
            }
          />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          />
        </Routes>
    </Box>
  );
}

function App() {
  return (
    <AppInfoProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </AppInfoProvider>
  );
}

export default App;